// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2":"patient","123":"case","391":"info","430":"doctor","857":"report","962":"home","966":"login"}[chunkId] + "." + {"2":"44ff9830","123":"f0c4e3be","391":"6cb9ddef","430":"b6e957e1","857":"1c65f9e2","962":"61f8a5c1","966":"dd940c9f"}[chunkId] + ".css";
};